import React from 'react';
import { Button } from 'reactstrap';

const Btn = ({ children, ...attrBtn }) => {
  return <Button {...attrBtn}>{children}</Button>;
};

export default Btn;
